import { FileAttachment } from "~/stores/slices/connection-attachments";

export const transformBackendAttachments = (
  backendAttachments: any[]
): FileAttachment[] => {
  return backendAttachments.map((attachment) => {
    // Create a proper File object with the correct name
    const dummyFile = new File([""], attachment.file_name, {
      type: "text/plain",
      lastModified: Date.now(),
    });

    return {
      fileId: attachment.file_id,
      description: attachment.description || "",
      isEditing: false,
      file: dummyFile,
      fileName: attachment.file_name,
      isUploading: false,
      isUploadError: false,
      isExisting: true,
    };
  });
};
